import type { PaymentInfo } from './types';

export const getTotalPayment = (paymentInfo: PaymentInfo) => {
  const { pricing, memberAmount, nonMemberAmount } = paymentInfo;
  const { price: memberPrice, point: memberPoint } = pricing.member;
  const { price: nonMemberPrice, point: nonMemberPoint } = pricing.nonMember;

  let paymentPrice = 0;
  let paymentPoints = 0;

  const memberTotalPrice = memberPrice ? memberPrice * memberAmount : 0;
  const memberTotalPoint = memberPoint ? memberPoint * memberAmount : 0;
  const nonMemberTotalPrice = nonMemberPrice
    ? nonMemberPrice * nonMemberAmount
    : 0;
  const nonMemberTotalPoint = nonMemberPoint
    ? nonMemberPoint * nonMemberAmount
    : 0;
  paymentPrice = memberTotalPrice + nonMemberTotalPrice;
  paymentPoints = memberTotalPoint + nonMemberTotalPoint;

  return {
    paymentPrice,
    paymentPoints,
  };
};
